/**
 * Patient-facing copy for appointments still in pending_approval.
 * Uses backend `proposalSource` so admin reschedule is not mistaken for doctor-only steps.
 */

/**
 * Secondary line shown under **Visit** when the accordion is collapsed (matches panel typography).
 *
 * @param {object | null | undefined} appointment API appointment with doctorAction, proposalSource (optional legacy)
 * @param {string} [providerLabel] "Doctor" | "Hospital"
 */
export function patientPendingAppointmentLeadMessage(appointment, providerLabel = "Doctor") {
  const plRaw = String(providerLabel || "").trim();
  const isHospital = /^hospital$/i.test(plRaw);
  const pl = isHospital ? "Hospital" : "Doctor";
  const plPoss = pl === "Doctor" ? "doctor" : "hospital";
  const da = String(appointment?.doctorAction || "").toLowerCase();
  const src = String(appointment?.proposalSource || "").toLowerCase();

  if (da === "pending") {
    return `Awaiting confirmation from your ${plPoss}. HealBid admin will finalize after ${plPoss} responds.`;
  }
  if (da === "accepted") {
    return `Your ${plPoss} accepted this visit — final approval is pending with HealBid admin.`;
  }
  if (da === "reschedule" || da === "custom") {
    if (src === "admin") {
      return "HealBid admin set a different visit time — awaiting final confirmation from admin (this supersedes any earlier provider acceptance).";
    }
    return `Your ${plPoss} suggested a different time — verification is pending with HealBid admin.`;
  }
  return `Visit request pending — awaiting your ${plPoss} and/or HealBid admin as applicable.`;
}

/**
 * Compact label for dashboards / pills while status is pending_approval (optional refinement).
 *
 * @param {object | null | undefined} appointment same fields as above
 * @param {string} [providerRole] "doctor" | "hospital" from API row
 */
export function patientPendingAppointmentShortLabel(appointment, providerRole) {
  const da = String(appointment?.doctorAction || "").toLowerCase();
  const src = String(appointment?.proposalSource || "").toLowerCase();
  const responder = providerRole === "hospital" ? "Hospital" : "Doctor";
  if (da === "pending") return `Awaiting ${responder}`;
  if (da === "accepted") return "Awaiting admin confirmation";
  if (da === "reschedule" || da === "custom") {
    if (src === "admin") return "Admin reschedule · Pending";
    return `${responder} reschedule · Pending admin`;
  }
  return "Pending approval";
}
